<shared-drop-down projection="global" [options]="items" (onSelected)="handleDropdownSelected($event)"
    class="collection-type-toggle-for-link-drop-down" [selected]="selected">
    <shared-link size="inherit" role="button" class="collection-type-toggle-for-link-drop-down__trigger"
        [inverted]="inverted">
        {{selected?.Name}}
        <shared-icon icon="down" class="collection-type-toggle-for-link-drop-down__icon">
        </shared-icon>
    </shared-link>
</shared-drop-down>